import React, { PureComponent, ReactNode, Suspense } from "react";
import styled from "styled-components";

import { translate } from "../../services/translation.service";
import theme from "../../theme";
import { IProduct } from "../../types/product";
import ProductCarousel from "../ProductCarousel";
import { ProductWrapper } from "../ProductWrapper";

const UnavailableCarousel = styled.p`
  && {
    margin: 40px 30px 10px 30px;
    color: ${theme.colors.grey};
    font-family: ${theme.fonts.regular};
    font-size: ${theme.fontSizes.regular};
  }
`;

const StyledProductCarousel = styled(ProductCarousel)`
  && .productImageWrapper > a > div {
    height: 190px;

    img {
      height: 100%;
      object-fit: contain;
    }
  }
`;

interface IProps {
  className?: string;
  products?: IProduct[];
  onClick?: (product: IProduct, productIndex: number) => void;
  dots?: boolean;
  hasCustomPaging?: boolean;
  maxSlides?: string;
}

export default class MiniProductsCarousel extends PureComponent<IProps> {
  public onClick = (product: IProduct, productIndex: number): void => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(product, productIndex);
    }
  };

  public render(): ReactNode {
    const {
      className,
      products,
      dots,
      hasCustomPaging,
      maxSlides,
    } = this.props;

    if (products && products.length > 0) {
      return (
        <StyledProductCarousel
          className={className}
          dots={dots}
          hasCustomPaging={hasCustomPaging}
          maxSlides={maxSlides}
          productsCount={products?.length || 0}
        >
          {products.map((product: IProduct, index: number) => (
            <Suspense fallback={<div />} key={index}>
              <ProductWrapper
                key={`${product.id}-${index}`}
                product={product}
                theme="mini"
                imageMaxHeight={170}
                onClick={(): void => this.onClick(product, index)}
              />
            </Suspense>
          ))}
        </StyledProductCarousel>
      );
    } else {
      return (
        <UnavailableCarousel className={className}>
          {translate("product.unavailableCarousel")}
        </UnavailableCarousel>
      );
    }
  }
}
